import { Alert } from '@interstate/components/Alert';
import { Typography } from '@interstate/components/Typography';
import { useSelector } from 'react-redux';
import * as customerSpdSelectors from '@makemydeal/dr-dash-store/selectors/customerSpdSelectors';

export const CustomerSpdErrorAlert = () => {
    const saveCustomerSpdError = useSelector(customerSpdSelectors.getSaveCustomerSpdHasError);

    if (!saveCustomerSpdError) {
        return null;
    }

    return (
        <Alert type="error">
            <Typography variant="body-sm">Unable to save Buyer/Co-Buyer details. Please save again.</Typography>
        </Alert>
    );
};
